import { MenuDownIcon } from "assests/GmsIcons";
import React, { useEffect, useState, useRef } from "react";
import useClickOutside from "../CustomHooks/useClickOutside";
type optionType = {
  label: string;
  value: string;
};
type propType = {
  id: string;
  onChange: (value: string) => void;
  value: string;
  options: optionType[];
  name: string;
  disabled?: boolean;
  hideLabel?: boolean;
  isSearchable?: boolean;
  hasMarginAtStart?:boolean;
};
const Select = (props: propType) => {
  const [selectedOptionLabel, setSelectedOptionLabel] = useState<string>("Select");
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [filteredOptions, setFilteredOptions] = useState<optionType[]>([]);
  const [selectedIndex, setSelectedIndex] = useState<number>(-1);
  const { showMenu, ref, handleClick } = useClickOutside();
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const option = props?.options?.filter((x: any) => x?.value === props?.value);
    setSelectedOptionLabel(option[0]?.label);
  }, [props?.value]);

  useEffect(() => {
    setFilteredOptions(
      props?.options?.filter((option) =>
        option?.label?.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [searchTerm, props.options]);

  useEffect(() => {
    if (showMenu && selectedIndex !== -1 && menuRef.current) {
      const selectedOptionElement = menuRef.current.childNodes[selectedIndex] as HTMLElement;
      selectedOptionElement?.scrollIntoView({ block: "center" });
    }
  }, [showMenu, selectedIndex]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (showMenu) {
      if (e.key === "ArrowUp" && selectedIndex > 0) {
        setSelectedIndex(selectedIndex - 1);
      } else if (e.key === "ArrowDown" && selectedIndex < filteredOptions.length - 1) {
        setSelectedIndex(selectedIndex + 1);
      } else if (e.key === "Enter" && selectedIndex !== -1) {
        const selectedValue = filteredOptions[selectedIndex]?.value;
        props.onChange(selectedValue);
        handleClick();
      }
    }
  };

  return (
    <React.Fragment>
      <div id={props.id} className="tw-flex tw-max-w-full">
        <div 
          id={`${props.id}-container`} 
          ref={ref} 
          className="tw-relative tw-bg-white tw-w-full" 
          onKeyDown={handleKeyDown}
        >
          <div
            id={`${props.id}-dropdown-trigger`}
            onClick={props?.disabled ? () => { } : handleClick}
            className={`${props?.hasMarginAtStart === false ? "" : "tw-ms-3"} ${showMenu ? "tw-bg-[#EBECF0] tw-border" : ""} ${props?.disabled ? "tw-bg-gray-100" : "hover:tw-bg-[#EBECF0]"
              }  tw-border tw-p-2 tw-rounded-[4px] tw-flex flex-row tw-items-center tw-justify-between tw-gap-[6px] tw-w-full`}
          >
            <button
              id={`${props.id}-select-button`}
              disabled={props?.disabled}
              className={`tw-text-sm tw-font-normal tw-w-auto  tw-text-[#172B4D]`}
            >
              <span 
                id={`${props.id}-label`}
                className="tw-mt-2 tw-text-gray-dark"
              >
                {props.hideLabel && selectedOptionLabel ? "" : props?.name}
              </span>
              <span 
                id={`${props.id}-selected-value`}
                className="tw-ms-2"
              >
                {selectedOptionLabel}
              </span>
            </button>
            <MenuDownIcon  />
          </div>
          {showMenu && (
            <div
              id={`${props.id}-menu`}
              ref={menuRef}
              className={`${props?.hasMarginAtStart === false ? "" : "tw-mx-3"} tw-origin-top-right tw-absolute tw-mt-1 tw-w-auto tw-rounded-[4px] tw-bg-white tw-ring-1 tw-ring-[#EBECF0]  tw-z-50 tw-max-h-[300px] tw-overflow-y-auto`}
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="options-menu"
            >
              {props?.isSearchable && (
                <input
                  id={`${props.id}-search-input`}
                  type="text"
                  placeholder="Search..."
                  className="tw-p-2 tw-rounded-[4px] tw-border tw-mb-2 tw-w-full"
                  value={searchTerm}
                  onChange={handleInputChange}
                />
              )}
              {filteredOptions.map((option: optionType, index: number) => (
                <div
                  id={`${props.id}-option-${index}`}
                  key={index}
                  onClick={() => {
                    props?.onChange(option?.value);
                    handleClick();
                  }}
                  className={`tw-w-full tw-flex tw-justify-between tw-items-center tw-py-1 tw-px-2 hover:tw-bg-[#dee3f6] ${selectedIndex === index ? "tw-bg-[#dee3f6]" : ""
                    }`}
                >
                  <label 
                      id={`${option.label}`}
                      className={`tw-ms-2 tw-text-[#091E42]  tw-text-sm`}
                    >
                      {option?.label}
                    </label>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default Select;
